import * as S from './styled'

export function MiniSpinner() {
  return (
    <S.Wrapper>
      <S.Spinner />
    </S.Wrapper>
  )
}
